import { Button, styled } from "@mui/material";

const PrimaryButton = styled(Button)({
  background: "linear-gradient(176deg, #895FF8 20%, #0C76F9)",
  textTransform: "none",
});

export default PrimaryButton;
